<template>
  <div>
    <mf-button
      v-if="ghost"
      color="marca-0-l20"
      class="mx-2"
      text
      :loading="loadingTutorial"
      :disabled="isDisabled"
      icon="help"
      label="Tutorial"
      @click="startTour"
    />

    <mf-button v-else color="marca-0-l20" outlined rounded label="Tutorial" :loading="loadingTutorial" :disabled="isDisabled" icon="help" @click="startTour" />
  </div>
</template>

<script>
import userflow from 'userflow.js'

export default {
  props: {
    tourIndex: {
      type: Number,
      default: 0,
    },
    loadingTutorial: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    ghost: {
      type: Boolean,
      default: false,
    },
    flowId: {
      type: String,
      default: '',
    },
  },
  computed: {
    isDisabled() {
      return this.loadingTutorial || this.disabled
    },
  },
  methods: {
    startTour() {
      if (this.flowId) {
        userflow.start(this.flowId)
      } else {
        this.$driver.startTour(this.tourIndex)
      }
    },
  },
}
</script>

<style lang="scss">
.unset-capitalize {
  text-transform: unset !important;
  letter-spacing: $letterspacing-1;
}
</style>
